import { createSelector } from 'reselect'

import { getLyraTherapyState } from '../../../data/lyraTherapy/clientSelectors'

const getMessenger = createSelector(getLyraTherapyState, (lyraTherapyState) => lyraTherapyState?.messenger)

export const getSelectedConversationId = createSelector(getMessenger, (messenger) => messenger?.selectedConversationId)

export const getMessengerDrafts = createSelector(getMessenger, (messenger) => messenger?.drafts)

export const getConversationsClient = createSelector(getMessenger, (messenger) => messenger?.conversationsClient)

export const inLiveMsgSession = createSelector(getMessenger, (messenger) => messenger?.inLiveMsgSession)

export const getMessagesActiveLiveMsgAppt = createSelector(getMessenger, (messenger) => messenger?.activeLiveMsgAppt)

export const getMessagesLiveMsgClientIdToOpen = createSelector(
  getMessenger,
  (messenger) => messenger?.liveMsgClientIdToOpen,
)

export const getInsertSmartSuggestionForClientId = createSelector(
  getMessenger,
  (messenger) => messenger?.insertSmartSuggestionForClientId,
)

export const getInsertMessageTemplateForClientId = createSelector(
  getMessenger,
  (messenger) => messenger?.insertMessageTemplateForClientId,
)

export const getInsertEssentialsArticleForClientId = createSelector(
  getMessenger,
  (messenger) => messenger?.insertEssentialsArticleForClientId,
)

export const getEssentialsArticleUrl = createSelector(getMessenger, (messenger) => messenger?.essentialsArticleUrl)

export const getUnsentMessage = createSelector(getMessenger, (messenger) => messenger?.unsentMessage ?? null)

export const getActiveClientMessengerId = createSelector(
  getMessenger,
  (messenger) => messenger?.activeClientMessengerId ?? null,
)

export const getMessageCenterTarget = createSelector(
  getMessenger,
  (messenger) => messenger?.messageCenterTarget ?? null,
)

export const getPendingInitialThreadId = createSelector(getMessenger, (messenger) => messenger?.pendingInitialThreadId)

export const getResolvedConversations = createSelector(
  getMessenger,
  (messenger) => messenger?.resolvedConversations ?? [],
)
